import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../api/axiosConfig';
import { Container, Form, Button, Alert, Spinner } from 'react-bootstrap';

const CreateAdmin = () => {
  const navigate = useNavigate();

  // State variables for admin fields
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  // Removing the status property
  // const [status, setStatus] = useState(1); // 1 for active, 0 for inactive

  const [siteId, setSiteId] = useState(''); // State for the selected site ID

  // State variables for API calls and errors
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  // State variable to store the list of sites
  const [sites, setSites] = useState([]);
  const [sitesLoading, setSitesLoading] = useState(true);
   const [sitesError, setSitesError] = useState("");

  // Load sites from the API
  useEffect(() => {
    const fetchSites = async () => {
      try {
        const response = await api.get('/sites');
        setSites(response.data.data || []); // Assuming the API returns { success: true, data: [...] }
      } catch (err) {
          console.error("Error fetching sites:", err.response || err.message);
          setSitesError("Failed to load sites.");
      } finally {
        setSitesLoading(false);
      }
    };

    fetchSites();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      const response = await api.post('/users', {
        name: name,
        email: email,
        mobile: mobile,
        password: password,
        // status: status, // Set status to active by default (1) - or remove entirely
        role: 'site_admin', // Set the role to "site_admin"
        site_id: siteId, // Include the site_id in the request
      });

      if (response.data.success) {
        setSuccessMessage('Administrator created successfully!');
        // Reset form fields
        setName('');
        setEmail('');
        setMobile('');
        setPassword('');
        // Remove reset status value
        // setStatus(1);
        setSiteId('');
        // Optionally, navigate back to the admins list
        navigate('/super-admin/admins');
      } else {
        setError(response.data.message || 'Failed to create administrator.');
      }
    } catch (err) {
      setError('An error occurred while creating the administrator.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <h1>Create New Administrator</h1>
      {error && <Alert variant="danger">{error}</Alert>}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="formName">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formMobile">
          <Form.Label>Mobile</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter mobile number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Group>

        {/* REMOVE THE formStatus  */}
        {/* <Form.Group className="mb-3" controlId="formStatus">
          <Form.Label>Status</Form.Label>
          <Form.Control
            as="select"
            value={status}
            onChange={(e) => setStatus(parseInt(e.target.value))}
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </Form.Control>
        </Form.Group> */}

        <Form.Group className="mb-3" controlId="formSiteId">
          <Form.Label>Site</Form.Label>
          {sitesLoading ? (
             <Spinner animation="border" size="sm" />
           ) : sitesError ? (
             <Alert variant="danger">{sitesError}</Alert>
           ) : (
          <Form.Control
            as="select"
            value={siteId}
            onChange={(e) => setSiteId(e.target.value)}
            required
          >
            <option value="">Select a Site</option>
            {sites.map((site) => (
              <option key={site.id} value={site.id}>
                {site.brand_name}
              </option>
            ))}
          </Form.Control>
          )}
        </Form.Group>

        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? 'Creating...' : 'Create Administrator'}
        </Button>
        <Button variant="secondary" onClick={() => navigate('/super-admin/admins')}>
          Cancel
        </Button>
      </Form>
    </Container>
  );
};

export default CreateAdmin;